export enum ETiptapAlignmentSelectorKey {
  LEFT = 'left',
  CENTER = 'center',
  RIGHT = 'right',
  JUSTIFY = 'justify',
}

export enum ETiptapSelectorKey {
  HEADING = 'heading',
  PARAGRAPH = 'paragraph',
  BOLD = 'bold',
  ITALIC = 'italic',
  UNDERLINE = 'underline',
  STRIKE = 'strike',
  SUBSCRIPT = 'subscript',
  SUPERSCRIPT = 'superscript',
  HIGHLIGHT = 'highlight',
  BULLET_LIST = 'bulletList',
  ORDERED_LIST_WITH_START = 'orderedListWithStart',
  TASK_LIST = 'taskList',
  TASK_ITEM = 'taskItem',
  LIST_ITEM = 'listItem',
  IMAGE = 'image',
  TABLE = 'table',
  LINK = 'link',
  INVISIBLE_CHARACTERS = 'invisibleCharacters',
  INLINE_BLOCK = 'inline-block',
  CUSTOM_STYLE_MARK = 'customStyleMark',
  SECTION = 'section',
}
